import i18next from 'i18next'

i18next.addResourceBundle('en', 'security', {
    select_user_mode: 'Select User Mode',
    allowProjectCreateDelete: 'Permit creating and deleting projects',
    allowBypassProtectedBranches: 'Allow Managers to bypass protected branches',
    allowBypassProtectedBranches_info_enabled: 'When enabled, users with the <0>Manager</0> role can merge changes directly into protected branches from the OpenL Studio UI. When disabled, protected branch restrictions apply uniformly to all users and merges must be completed using external Git tooling.',
    allowBypassProtectedBranches_info_scope_intro: 'The bypass follows the scope of the assigned <0>Manager</0> role:',
    allowBypassProtectedBranches_info_scope_project: 'If granted at the <0>project</0> level, the bypass applies to that project only.',
    allowBypassProtectedBranches_info_scope_repository: 'If granted at the <0>repository</0> level, the bypass applies to all projects in the repository.',
    allowBypassProtectedBranches_info_note: '<0>Note:</0> The <0>Manager</0> role also grants permission to manage access rights for other users and groups on the resource. It is not currently possible to grant merge-bypass authority without also granting role management rights.',
    select_user_mode_info: 'User mode defines how many users can run the application and where user projects will be located by default.',
    configure_initial_users: 'Configure Initial Users',
    configure_initial_users_info: 'Add a list of comma-separated users with administrator privileges and decide whether to grant view access for OpenL Studio to the newly created users.',
    configure_active_directory: 'Configure Active Directory',
    configure_active_directory_info: 'Set up an Active Directory to use for managing users in OpenL Studio. Please contact your System Administrator for this information if necessary.',
    configure_saml: 'Configure SAML',
    configure_saml_info: 'Set up SAML to use for managing users in OpenL Studio. Please contact your System Administrator for this information if necessary.',
    configure_oauth2: 'Configure OAuth2',
    configure_oauth2_info: 'Set up OAuth2 to manage users in OpenL Studio. If necessary, contact your system administrator.',
    user_modes: {
        single: 'Single-User',
        multi: 'Multi-User',
        ad: 'Active Directory',
        saml: 'SSO: SAML',
        oauth2: 'SSO: OIDC (OAuth2)',
    },
    user_mode_description: {
        'single': '',
        'multi': '',
        'ad': '',
        'saml': '',
        'oauth2': '',
    },
    // Form fields
    user_mode: 'User Mode',
    administrators: 'Administrators',
    default_group: 'Default Group',
    default_group_info_aria: 'Default group information',
    default_group_none: 'None',
    default_group_not_found: 'This group no longer exists. Go to Security → Default Group to set a valid group.',
    default_group_tooltip: 'Default Group is applied to all users automatically. A user\'s effective access may come from this Default Group, even if no groups are explicitly assigned. To change it, go to <strong>Security → Default Group</strong>. Select <strong>None</strong> to prevent any default access for users.',
    client_id: 'Client ID',
    issuer_uri: 'Issuer URI',
    client_secret: 'Client Secret',
    scope: 'Scope',
    entity_id: 'Entity ID',
    saml_server_metadata_url: 'SAML Server Metadata URL',
    saml_remote_server_certificate: 'SAML Remote Server X509 Certificate (PEM base64 encoded format, begin/end tags are NOT needed)',
    active_directory_domain: 'Active Directory Domain',
    active_directory_url: 'Active Directory URL',
    user_filter: 'User Filter',
    group_filter: 'Group Filter',
    attribute_for_username: 'Attribute for Username',
    attribute_for_first_name: 'Attribute for First Name',
    attribute_for_last_name: 'Attribute for Last Name',
    attribute_for_display_name: 'Attribute for Display Name',
    attribute_for_email: 'Attribute for Email',
    attribute_for_groups: 'Attribute for Groups',
    username: 'Username',
    email: 'Email',
    first_name: 'First Name',
    last_name: 'Last Name',
    display_name: 'Display Name',
    // Validation messages
    username_max_length: 'Username must be at most 125 characters long',
    first_name_max_length: 'First Name must be at most 125 characters long',
    last_name_max_length: 'Last Name must be at most 125 characters long',
    display_name_max_length: 'Display Name must be at most 255 characters long',
    // Login page
    sign_in_to_openl_studio: 'Sign in to OpenL Studio',
    username_label: 'Username',
    password_label: 'Password',
    log_in_button: 'Log in',
    login_failed_message: 'Login failed. Please verify your credentials and try again.',
    username_required: 'Please enter your username',
    password_required: 'Please enter your password',
    // Info modals
    confirm_apply_configuration: 'Are you sure you want to apply the configuration?',
    confirm_apply_configuration_message: 'All users working with OpenL Studio now will lose all unsaved changes. This will restart the application.',
})
